export const UsefulContacts = () => {
  return (
    <span className="normal-case text-lg mx-2" style={{ marginBlock: '6px' }}>
      Please find contact details for our dedicated supplier helpdesk{' '}
      <a
        className="text-primary underline"
        href="https://www.morrisons-corporate.com/suppliers/meet-our-buyers"
        target="_blank"
        rel="noopener noreferrer"
      >
        here
      </a>
    </span>
  )
}
